export default "__VITE_PUBLIC_ASSET__8f86af89__"